import React, { useState } from "react";

import { ADMIN_APP_NAME } from "./appConfig";
import { hasSupabaseEnv, supabase } from "./supabaseClient";

export default function LoginPanel({}) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [resetting, setResetting] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  if (!hasSupabaseEnv || !supabase) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <p className="eyebrow">Admin</p>
          <h1>{ADMIN_APP_NAME} saknas</h1>
          <p className="auth-description">
            Fyll i <code>REACT_APP_SUPABASE_URL</code> och{" "}
            <code>REACT_APP_SUPABASE_ANON_KEY</code> i adminappens{" "}
            <code>.env</code> innan du loggar in i {ADMIN_APP_NAME}.
          </p>
        </div>
      </div>
    );
  }

  async function handleLogin(event) {
    event.preventDefault();
    setSubmitting(true);
    setError("");
    setMessage("");

    const { error: signInError } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (signInError) {
      setError(signInError.message || "Kunde inte logga in.");
    }

    setSubmitting(false);
  }

  async function handleResetPassword() {
    if (!email.trim()) {
      setError("Ange e-postadressen som ska få återställningslänken.");
      setMessage("");
      return;
    }

    setResetting(true);
    setError("");
    setMessage("");

    const { error: resetError } = await supabase.auth.resetPasswordForEmail(
      email,
      {
        redirectTo: window.location.origin,
      },
    );

    if (resetError) {
      setError(resetError.message || "Kunde inte skicka återställningslänk.");
      setResetting(false);
      return;
    }

    setMessage("Om kontot finns har ett mejl med återställningslänk skickats.");
    setResetting(false);
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <p className="eyebrow">{ADMIN_APP_NAME}</p>
        <h1>Logga in</h1>
        <p className="auth-description">
          Logga in på {ADMIN_APP_NAME} för att redigera webbplatsens innehåll.
        </p>
        <form className="auth-form" onSubmit={handleLogin}>
          <label className="field">
            <span>E-post</span>
            <input
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
            />
          </label>
          <label className="field">
            <span>Lösenord</span>
            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              autoComplete="current-password"
              required
            />
          </label>
          {error ? <p className="feedback feedback--error">{error}</p> : null}
          {message ? (
            <p className="feedback feedback--success">{message}</p>
          ) : null}
          <div className="auth-actions">
            <button
              type="submit"
              className="button button--primary"
              disabled={submitting}
            >
              {submitting ? "Loggar in..." : "Logga in"}
            </button>
            <button
              type="button"
              className="button button--ghost"
              disabled={resetting}
              onClick={handleResetPassword}
            >
              {resetting ? "Skickar..." : "Reset password"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
